import QuestionAnswerFragment from "./QuestionAnswerFragment";
import WithLoadable from "../../helpers/WithLoadable";

// export default QuestionAnswerFragment;

export default WithLoadable({
	loader: () => import("./QuestionAnswerFragment"),
	modules: ["./QuestionAnswerFragment"],
	webpack: () => [require.resolveWeak("./QuestionAnswerFragment")]
});



// WEBPACK FOOTER //
// ./src/pages/QuestionAnswerFragment/index.tsx